export const ITEM_HORIZONTAL_PADDING = 40
export const MOBILE_ITEM_HORIZONTAL_PADDING = 16
